import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from "@angular/core";
import { coerceBooleanProperty } from "@angular/cdk/coercion";

/**
 * Card surface. Compose with bv-card-header / bv-card-body / bv-card-footer
 * (and bv-card-title / bv-card-desc inside the header).
 *
 *   <bv-card interactive>
 *     <bv-card-header>
 *       <bv-card-title>Tournament</bv-card-title>
 *       <bv-card-desc>10 players</bv-card-desc>
 *     </bv-card-header>
 *     <bv-card-body>…</bv-card-body>
 *     <bv-card-footer>
 *       <button bv-button variant="ghost">Cancel</button>
 *       <button bv-button variant="primary">Open</button>
 *     </bv-card-footer>
 *   </bv-card>
 */
@Component({
    selector: "bv-card",
    template: "<ng-content></ng-content>",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-card",
        "[class.bv-card--interactive]": "interactive",
    }
})
export class BvCardComponent {
  @Input({ transform: booleanAttribute }) interactive = false;
}

@Component({
    selector: "bv-card-header",
    template: "<ng-content></ng-content>",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "bv-card-header" }
})
export class BvCardHeaderComponent {}

/**
 * Card title. Defaults to `--font-sans` (Muli). Set `display` to switch
 * to `--font-display` (Oswald) — used for tournament names, league
 * names, and other prominent identifiers.
 *
 *   <bv-card-title>Standard title</bv-card-title>
 *   <bv-card-title display>Tournament name</bv-card-title>
 */
@Component({
    selector: "bv-card-title",
    template: "<ng-content></ng-content>",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-card-title",
        "[class.bv-card-title--display]": "display",
    }
})
export class BvCardTitleComponent {
  @Input()
  get display(): boolean { return this._display; }
  set display(v: any) { this._display = coerceBooleanProperty(v); }
  private _display = false;
}

@Component({
    selector: "bv-card-desc",
    template: "<ng-content></ng-content>",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "bv-card-desc" }
})
export class BvCardDescComponent {}

@Component({
    selector: "bv-card-body",
    template: "<ng-content></ng-content>",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "bv-card-body" }
})
export class BvCardBodyComponent {}

@Component({
    selector: "bv-card-footer",
    template: "<ng-content></ng-content>",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "bv-card-footer" }
})
export class BvCardFooterComponent {}
